import { Subject } from 'rxjs'
/**
 * this listens to play progress points
 * ie. 25%, 50%, 75%
 * to send events to GA
 */
export const sendProgressToGA$ = new Subject()
